export default "__VITE_ASSET__0ad67ff5__"